/**
 * Better Auth — the browser half. The UI talks to this, never to the server
 * module.
 */
import { oauthProviderClient } from '@better-auth/oauth-provider/client'
import { inferAdditionalFields, organizationClient } from 'better-auth/client/plugins'
import { createAuthClient } from 'better-auth/react'
import { personNameAuthFields } from '@/core/users'

export const authClient = createAuthClient({
  // Same origin: the Hono server mounts the auth handler at /api/auth/*.
  basePath: '/api/auth',
  plugins: [
    organizationClient(),
    // AI apps signing in through us (docs/MCP.md): adds the signed OAuth query
    // from the address bar to sign-in and consent calls, and gives `authClient.oauth2.*`.
    oauthProviderClient(),
    // First and last name (src/core/users/name.ts), so sign-up can send them.
    inferAdditionalFields({ user: personNameAuthFields }),
  ],
})

export const { signIn, signUp, signOut, useSession, resetPassword } = authClient

/**
 * Better Auth 1.7 exposes the "send me a reset link" call as
 * requestPasswordReset; the older `forgetPassword` name is gone from the typed
 * client. Aliased so screens read the way people talk.
 */
export const requestPasswordReset = authClient.requestPasswordReset
